import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { getAsset } from "../../helpers/helper";
import { images } from "../../constants";
import Reportreplymodal from "../report_suggest_d-modal";
import { useReportReply } from "../../hooks/report-reply/useReportReply";
import noImagePlaceholder from "../../assets/images/dummy/user-avatar-img.jpg";

const Reportreply = ({ reportdata, servicedata }) => {
  const {
    lgShow,
    setLgShow,
    singledata,
    isQueryLoading,
    dataFetch,
    servicedataFetch,
  } = useReportReply();

  return (
    <>
      <Reportreplymodal
        setLgShow={setLgShow}
        lgShow={lgShow}
        singledata={singledata}
        title="Report Reply"
        isLoading={isQueryLoading}
      />
      <Container className="px-0">
        <div style={{ width: "100%" }} className="mt-2">
          <img src={images.Bannerimage} style={{ width: "100%" }} alt="Banner" />
        </div>
        <div className="d-flex align-items-center mt-2 mb-4 px-2">
          <h4 className="mb-0 ms-3">Report Reply</h4>
        </div>
        <div className="scrll noscroll">
          {/* Report Data */}
          {reportdata && reportdata?.length > 0 ? (
            reportdata?.map((e) => (
              <Row key={e?.shopId?._id} className="align-items-center">
                <Col className="mt-2" lg="1">
                  <img
                    className="ms-3 pi-ck"
                    src={e?.imageUrl?.[0] ? getAsset(e?.imageUrl[0]) : noImagePlaceholder}
                    alt=""
                    crossOrigin="anonymous"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                    onError={(ev) => {
                      ev.currentTarget.onerror = null;
                      ev.currentTarget.src = noImagePlaceholder;
                    }}
                  />
                </Col>
                <Col className="mt-2" lg="9">
                  <h6 className="-size m-0">Name: {e?.shopId?.shopname}</h6>
                  <p className="PHERA-0 mb-0">
                    <span style={{ fontWeight: "600" }}>ID:</span> {e?.shopId?._id}
                  </p>
                  <p className="PHERA mb-0 mt-1">
                    <span style={{ fontWeight: "600" }}>Message:</span>{" "}
                    {e?.reports[0]?.reply?.message?.length > 100
                      ? e?.reports[0]?.reply?.message?.slice(0, 100) + "..."
                      : e?.reports[0]?.reply?.message}
                  </p>
                </Col>
                <Col lg="2">
                  <div className="d-flex">
                    <Col>
                      <button
                        type="button"
                        className="button-01 ms-4 mt-4"
                        onClick={() => {
                          dataFetch(e?.shopId?._id, e?.reports[0]?._id);
                        }}
                      >
                        Read
                      </button>
                    </Col>
                  </div>
                </Col>
                <hr />
              </Row>
            ))
          ) : (
            <div className="d-flex justify-content-center">
              <h5>No Report Data Found</h5>
            </div>
          )}

          {/* Service Data */}
          {servicedata && servicedata?.length > 0 ? (
            servicedata?.map((e) => (
              <Row key={e?.serviceId?._id}>
                <Col className="mt-2" lg="1">
                  <img
                    className="ms-3 pi-ck"
                    src={e?.serviceId?.images?.[0] ? getAsset(e?.serviceId?.images[0]) : noImagePlaceholder}
                    alt=""
                    crossOrigin="anonymous"
                    style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "50%" }}
                    onError={(ev) => {
                      ev.currentTarget.onerror = null;
                      ev.currentTarget.src = noImagePlaceholder;
                    }}
                  />
                </Col>
                <Col className="mt-2" lg="9">
                  <h6 className="-size m-0">Name: {e?.serviceId?.profileName}</h6>
                  <p className="PHERA-0 mb-0">
                    <span style={{ fontWeight: "600" }}>ID:</span> {e?.serviceId?._id}
                  </p>
                  <p className="PHERA mb-0 mt-1">
                    <span style={{ fontWeight: "600" }}>Message:</span>{" "}
                    {e?.reports[0]?.reply?.message?.length > 100
                      ? e?.reports[0]?.reply?.message.slice(0, 100) + "..."
                      : e?.reports[0]?.reply?.message}
                  </p>
                </Col>
                <Col lg="2">
                  <div className="d-flex">
                    <Col>
                      <button
                        type="button"
                        className="button-01 ms-4 mt-4"
                        onClick={() => {
                          servicedataFetch(e?.serviceId?._id, e?.reports[0]?._id);
                        }}
                      >
                        Read
                      </button>
                    </Col>
                  </div>
                </Col>
                <hr />
              </Row>
            ))
          ) : (
            ""
          )}
        </div>
      </Container>
    </>
  );
};

export default Reportreply;
